import React from 'react'
import { LeftSidebarView, ViewBody } from 'components/Sidebar'
import {
  ButtonGroup,
  Alert,
} from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import CardBlockers from 'components/CardBlockers'
import Button from 'components/Button'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import Scrollbars from './Scrollbars'
import styled from 'styled-components'

const StyledAlert = styled(Alert)`
  box-shadow: none;
`

const ButtonsWrapper = styled(ViewBody)`
  margin-top: 10px;
  margin-bottom: 10px;
`

type Props = LeftSidebarProps & {
  id: number;
  name: string;
  boardId?: number;
  onRemove: () => void;
}

const BlockerInUseRemoveView: React.FC<Props> = ({
  leftSidebar,
  id,
  name,
  boardId,
  onRemove,
}) => {
  const close = () => {
    leftSidebar.pop()
  }

  return (
    <LeftSidebarView
      title={name}
    >
      <ViewBody>
        <StyledAlert bsStyle='warning'>
          <FormattedMessage
            id={
              boardId
                ? 'BLOCKERS_REMOVE_FROM_BOARD_CARD_BLOCKERS_EXIST'
                : 'BLOCKERS_REMOVE_CARD_BLOCKERS_EXIST'
            }
          />
        </StyledAlert>
      </ViewBody>
      <Scrollbars>
        <CardBlockers
          blockerId={id}
          boardId={boardId}
        />
      </Scrollbars>
      <ButtonsWrapper>
        <ButtonGroup>
          <Button
            bsStyle='warning'
            onClick={() => {
              onRemove()

              close()
            }}
          >
            <FormattedMessage id='REMOVE' />
          </Button>
          <Button onClick={close}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
      </ButtonsWrapper>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(BlockerInUseRemoveView)
